export function ticketPostedBy(row: {
  firstName?: string;
  lastName?: string;
}) {
  return [row.firstName, row.lastName].filter(Boolean).join(" ").trim() || "—";
}

export function ticketAssignedLabel(row: {
  assignedTo?: string;
  assignedUserFirstName?: string;
  assignedUserLastName?: string;
  assignedUserEmail?: string;
}) {
  if (
    row.assignedUserFirstName &&
    row.assignedUserLastName &&
    row.assignedUserEmail
  ) {
    return `${row.assignedUserFirstName} ${row.assignedUserLastName} - ${row.assignedUserEmail}`;
  }
  return row.assignedUserEmail || row.assignedTo || "";
}

export function ticketPriorityStyle(priority?: string) {
  if (priority === "HIGH") return { backgroundColor: "#F44336", color: "white" };
  if (priority === "MEDIUM") return { backgroundColor: "#FFC107", color: "black" };
  return { backgroundColor: "#4CAF50", color: "white" };
}

export function ticketStatusStyle(status?: string) {
  if (status === "NEW") return { backgroundColor: "#52cdff", color: "white" };
  if (status === "INPROGRESS") return { backgroundColor: "#ffa725", color: "black" };
  if (status === "CLOSED") return { backgroundColor: "#9E9E9E", color: "white" };
  return { backgroundColor: "", color: "white" };
}

export const TICKET_CATEGORIES = [
  "Retreat Registration",
  "Retreat Financials",
  "Retreat Roster",
  "Retreat Closure",
  "Database Issues",
  "Retreat Reports",
  "Request to Feature",
  "How do I...",
  "Other",
];
